import { render } from "./quotation-list-modal.vue?vue&type=template&id=2836476a"
import script from "./quotation-list-modal.vue?vue&type=script&lang=js"
export * from "./quotation-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__